import { InvoiceFormReceiver } from '@features/invoices/types/invoiceForm/invoiceFormReceiver'
import type { ProductType } from '@features/products/enums/productType'
import type { GetFilteredVatRates } from '@features/vatRates/hooks/useFilteredVatRates'
import type { VatRate } from '@features/vatRates/types/vatRate'

export const getAvailableVatRatesForReceiver = (
  receiver: InvoiceFormReceiver,
  getFilteredVatRates?: GetFilteredVatRates,
): ((productType: ProductType) => VatRate[]) | undefined =>
  getFilteredVatRates &&
  ((productType) =>
    getFilteredVatRates({ contactCountryCode: receiver.countryId, contactType: receiver.type, productType }))
